import { useQueries, useQuery } from '@tanstack/react-query';

import { acceso360Client } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { UUID } from '@/types';

import { User } from '../types/types';

import { userQueryKeys } from './query-keys';

export interface GetUserParams {
  id: UUID;
}

export function getUser({ id }: GetUserParams): Promise<User> {
  return acceso360Client.get(`/iam/api/v1/users/${id}`).then(({ data }) => data);
}

type QueryFnType = typeof getUser;

interface UseUserParams {
  id?: UUID;
  config?: QueryConfig<QueryFnType>;
}

export function useUser({ id, config = {} }: UseUserParams) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    enabled: !!id,
    queryKey: userQueryKeys.detail(id),
    queryFn() {
      if (!id) {
        throw new Error('User id is required');
      }

      return getUser({ id });
    },
  });
}

interface UseUsersByIdsParams {
  ids?: UUID[];
}

export function useUsersByIds({ ids = [] }: UseUsersByIdsParams) {
  return useQueries({
    queries: ids.map(id => ({
      enabled: !!id,
      queryKey: userQueryKeys.detail(id),
      queryFn() {
        if (!id) {
          throw new Error('User id is required');
        }

        return getUser({ id });
      },
    })),
  });
}
